<template>
  <div class="bg-gradient-to-r from-primary-140 to-primary-40 py-10 lg:py-20 text-center">
    <h2 class="text-white p-4">
      Explore Summit Subscriptions
    </h2>
    <p class="font-bold text-accent-light pb-8">
      For slightly more than the cost of a single 6-hour course, you can unlock unlimited access for an entire year!
    </p>
    <l-subscription-options :three-cards="threeCards" />
  </div>
</template>

<script>
export default {
  name: 'GradientSection',
  props: {
    threeCards: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
